import { TextFieldProps } from '@mui/material';
import { add } from 'date-fns';

export const commonInputProps: Partial<TextFieldProps> = {
  margin: 'none',
  fullWidth: true,
  size: 'small',
  variant: 'outlined',
};

export const tomorrow = () => add(new Date(), { days: 1 });
